import * as ReduxObservable from 'redux-observable'
import {epic as analyticsEpic} from './analytics/epic'
import {epic as knowledgeTierEpic} from './knowledge-tiers/epic'
import {epic as onboardingSessions} from './onboarding-sessions/epic'
import {epic as otherClicksEpic} from './other-clicks/epic'
import {epic as promotionsEpic} from './promotions/epic'
import {epic as todayEpic} from './today/epic'
import {epic as topArticlesEpic} from './top-articles/epic'
import {epic as topSourcesEpic} from './top-sources/epic'
import {epic as topTopicsEpic} from './top-topics/epic'

export const epic = ReduxObservable.combineEpics(
  analyticsEpic,
  knowledgeTierEpic,
  onboardingSessions,
  otherClicksEpic,
  promotionsEpic,
  todayEpic,
  topArticlesEpic,
  topSourcesEpic,
  topTopicsEpic,
)



// WEBPACK FOOTER //
// ./src/pages/reports/epic.ts